import { FilterTypes } from '../../common/components/filter/filterbar/types';
import { UserRolePreferencesSettingsSettings } from './types';

/**
 * Merge a partial patch onto the current preferences blob.
 *
 * `save()` replaces the whole settings object and cuts a new version, so every writer must
 * spread the existing settings or it silently drops sibling keys (saved filter groups, seen
 * tours, other features' column choices). Centralised so every caller uses the same base
 * fallback and no writer diverges.
 */
export const buildNextUserRolePreferencesSettings = <T extends FilterTypes>(
  currentSettings: UserRolePreferencesSettingsSettings<T> | undefined,
  patch: Partial<UserRolePreferencesSettingsSettings<T>>
): UserRolePreferencesSettingsSettings<T> => ({
  myFilterGroups: [],
  profile: {},
  ...currentSettings,
  ...patch,
});
